jQuery(document).ready(function($) {

//SMOOTH SCROLL

$('a[href^="#"]').on('click',function (e) {
	    e.preventDefault();

	    var target = this.hash;
	    var $target = $(target);
		
		if ($(window).width() < 860) {
		  	  $('html, body').stop().animate({
		        'scrollTop': $target.offset().top - 80
		    }, 500, 'swing', function () {
		        window.location.hash = target;
		    });
		} else {
			$('html, body').stop().animate({
		        'scrollTop': $target.offset().top - 100
		    }, 500, 'swing', function () {
		        window.location.hash = target;
		    });
		}
		
		
	   
	   
	   	
	   
		
	});

	
//MOBILE MENU
	
	// slide out mobile menu on btn click
		$( ".mobile-menu" ).click(function() {
		  $( ".main-nav" ).slideToggle("fast");
		  $( this ).toggleClass("active");
		});
		
  
    // close mobile menu on menu link click
          if ($(window).width() < 860) {
               $( ".main-nav" ).slideUp("fast");
          }
	
	
	
	
// SHOW/HIDE 
	$(".show-hide-content").hide();

	$( ".show-hide-link" ).click(function() {
		  $( ".show-hide-content" ).slideToggle("fast");
		  $( this ).toggleClass("showing");
	});

	

	

//  MAKE VIDEO EMBEDS RESPONSIVE

	//wrap iframes in a container 
	


// video
		
    
});


